/*
 * Created on Thu Oct 12 2023 10:21:42 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import * as types from "../action/types";
const scheduledData = localStorage.getItem("scheduledProducts");

const initialState = {
  paidScheduledProducts: scheduledData < 1 ? [] : JSON.parse(scheduledData),
  orderDetails: [], // Store order details properly
};

// Define action type
export const SET_ORDER = "SET_ORDER";

const orderReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GET_ALL_ORDERS_BY_ACCOUNT_STATUS:
    case types.GET_ORDER_BY_ID:
    case types.GET_ALL_ORDERS_BY_ACCOUNT_ID:
    case types.GET_USER_SCHEDULED_PRODUCTS:
      return {
        ...state,
        paidScheduledProducts: payload,
      };

    // Fix setOrder action
    case SET_ORDER:
      return {
        ...state,
        orderDetails: [...state.orderDetails, payload], // Append orders properly
      };

    default:
      return state;
  }
};

// Export setOrder action creator
export const setOrder = (order) => ({
  type: SET_ORDER,
  payload: order,
});

export default orderReducer;
